import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Camera, FileEdit, Send, CheckCircle2 } from "lucide-react";

export const HowToUse = () => {
  const steps = [
    {
      icon: Camera,
      title: "1. Snap a Photo",
      description: "Take a photo of the damaged area or repair site. Our AI will analyze it instantly.",
      example: "Example: Photo of a broken fence, damaged roof, or electrical wiring"
    },
    {
      icon: FileEdit,
      title: "2. Review & Edit Quote",
      description: "AI generates materials list with costs. Edit quantities, add items, or adjust labor costs.",
      example: "Example: Change '5 wooden planks' to '10', adjust labor from RM 200 to RM 250"
    },
    {
      icon: Send,
      title: "3. Send Invoice",
      description: "Add client details and send professional PDF invoice via email or Telegram instantly.",
      example: "Example: Email to john@example.com or Telegram to +60123456789"
    },
    {
      icon: CheckCircle2,
      title: "4. Get Paid Faster",
      description: "Clients receive detailed invoices immediately. Track history and manage clients easily.",
      example: "Average time from photo to sent invoice: 2 minutes"
    }
  ];

  return (
    <Card className="border-primary/20 bg-gradient-to-br from-primary/5 to-accent/5">
      <CardHeader>
        <CardTitle className="text-2xl">How SnapBill Works</CardTitle>
        <CardDescription>
          From photo to paid invoice in minutes - here&apos;s how to use SnapBill
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {steps.map((step, index) => (
          <div key={index} className="flex gap-4">
            <div className="flex-shrink-0">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
                <step.icon className="h-6 w-6 text-primary" />
              </div>
            </div>
            <div className="flex-1 space-y-1">
              <h3 className="font-semibold text-lg">{step.title}</h3>
              <p className="text-muted-foreground">{step.description}</p>
              <p className="text-sm text-primary/70 italic">{step.example}</p>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
